import { useSectionsRoutePrefixHook } from '@ingenico/react-section-utils';
import { useParams } from 'react-router';

export function useProvisioningSectionRoutePrefix(): string {
  const sectionsRoute = useSectionsRoutePrefixHook();
  const { organizationName } = useParams<{ organizationName?: string }>();
  // Use an api to enforce the typing because right now useSectionsRoutePrefixHook returns a Record<string, string>
  // and we need to have the MFE name as a key
  return sectionsRoute.provisioning ?? (organizationName ? `/${organizationName}` : '');
}
